import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { msalConfig } from './auth/authConfig';
import { setMsalInstance } from './services/api';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import KanbanBoard from './pages/KanbanBoard';
import SubBoard from './pages/SubBoard';
import OperacaoPage from './pages/OperacaoPage';
import NovasOperacoes from './pages/NovasOperacoes';
import Divergencias from './pages/Divergencias';
import Enquadramento from './pages/Enquadramento';
import HomologacaoEnquadramento from './pages/HomologacaoEnquadramento';
import AdminUsuarios from './pages/AdminUsuarios';
import AdminParametrosNormativos from './pages/AdminParametrosNormativos';
import AdminParametrosInstituicao from './pages/AdminParametrosInstituicao';
import ConectarISolve from './pages/ConectarISolve';
import ImportarPloomes from './pages/ImportarPloomes';
import Documentos from './pages/Documentos';
import Extensoes from './pages/Extensoes';
import AdminExtensoesTokens from './pages/AdminExtensoesTokens';
import AdminEtapasEsteira from './pages/AdminEtapasEsteira';
import { useCurrentUser } from './hooks/useCurrentUser';

const msalInstance = new PublicClientApplication(msalConfig);
setMsalInstance(msalInstance);

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>

        <AuthenticatedTemplate>
          <AuthenticatedApp />
        </AuthenticatedTemplate>
      </BrowserRouter>
    </MsalProvider>
  );
}

// Componente interno: carrega papel real do backend antes de renderizar as rotas.
function AuthenticatedApp() {
  const { currentUser, carregando } = useCurrentUser();

  if (carregando) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <span className="text-slate-400 text-sm">Carregando…</span>
      </div>
    );
  }

  const isAdmin = currentUser?.papel === 'ADMIN';

  return (
    <>
      <Toaster richColors position="top-right" />
      <Routes>
        {/* Todas as rotas autenticadas vivem dentro da casca (sidebar + topbar) */}
        <Route element={<AppShell currentUser={currentUser} />}>
          <Route path="/" element={<KanbanBoard />} />
          <Route path="/esteira/:esteira" element={<SubBoard />} />
          <Route path="/operacoes/:id" element={<OperacaoPage />} />
          <Route path="/novas-operacoes" element={<NovasOperacoes />} />
          <Route path="/documentos" element={<Documentos />} />
          <Route path="/extensoes" element={<Extensoes />} />
          <Route path="/divergencias" element={<Divergencias />} />
          <Route path="/enquadramento" element={<Enquadramento />} />
          <Route path="/homologacao-enquadramento" element={<HomologacaoEnquadramento />} />
          {/* Qualquer usuário autenticado+ativo pode conectar a sessão iSolve */}
          <Route path="/conectar-isolve" element={<ConectarISolve />} />
          <Route path="/integracoes/ploomes" element={isAdmin ? <ImportarPloomes /> : <Navigate to="/" replace />} />
          {/* Rotas /admin - só ADMIN acessa; outros são redirecionados */}
          <Route
            path="/admin/usuarios"
            element={isAdmin ? <AdminUsuarios /> : <Navigate to="/" replace />}
          />
          <Route
            path="/admin/parametros-normativos"
            element={isAdmin ? <AdminParametrosNormativos /> : <Navigate to="/" replace />}
          />
          <Route
            path="/admin/parametros-instituicao"
            element={isAdmin ? <AdminParametrosInstituicao /> : <Navigate to="/" replace />}
          />
          <Route
            path="/admin/etapas-esteira"
            element={isAdmin ? <AdminEtapasEsteira /> : <Navigate to="/" replace />}
          />
          <Route
            path="/admin/extensoes-tokens"
            element={isAdmin ? <AdminExtensoesTokens /> : <Navigate to="/" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
